<template>
  <!-- 座位查询 -->
  <div class="seat_listbox">
      <div class="topbox">
         <h5>座位查询</h5>
        <van-search v-model="searchValue"  placeholder="请输入姓名查询" @search="goSearch(searchValue)"/>
        <van-button class="searchBtn" block @click="goSearch(searchValue)">查询</van-button>
      </div>
     <div class="s_list">
       <van-notice-bar v-if="text != ''" color="#1989fa" background="#ecf9ff" wrapable  :scrollable="false" left-icon="info-o" :text='text'>
      </van-notice-bar>
        <div class="seat_box" style="min-height:200px;" v-if="text != ''">
        <van-row v-for="items2 in list2">
          <van-col span="10">
            <van-image class="imgbox" src="/static/images/member_default1.png" />
            <p>{{items2.name}}</p>
          </van-col>
          <van-col span="8" class="number">{{items2.tel}}</van-col>
          <van-col span="6" class="click iconfont" @click="goPath(items2)">查看座位&#xe633;</van-col>
        </van-row>
        </div>
       <h5 >查询到您的订单中包含如下用户：</h5>
       <div  class="seat_box">
          <template v-for="item in list">
            <van-row v-for="items in item.member">
              <van-col span="10">
                <van-image class="imgbox" src="/static/images/member_default1.png" />
                <p>{{items.name}}</p>
              </van-col>
              <van-col span="8" class="number">{{items.tel}}</van-col>
              <van-col span="6" class="click iconfont" @click="goSearch(items.name)">查询座位&#xe633;</van-col>
            </van-row>
          </template>
        </div>
     </div>
    <!--浮动按钮-->
    <template v-if="Object.keys(conference).length != 0">
      <footerFixed :id="conference.id" :jump-page="conference.jump_page"/>
    </template>
    <van-popup v-model="!tips.is_search" position="top" :style="{ height: '100%' }">
      <van-empty image="search" :description="tips.search_tips" />
    </van-popup>
  </div>
</template>

<script>
  import {
    formatDates,
    formatWeekDate
  } from "@/assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        order_no: '',
        conference: {},
        list:[],
        list2:[],
        text:'',
        footerNav: false,
        searchValue:'',//搜索内容
        tips:{
          is_search:true
        }
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates, //调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
      formatWeekDate //
    },
    created: function() {
      var _this = this;
      _this.order_no = _this.$route.params.order_no;
      _this.loadEnroll();
    },
    methods: {
      //打开底部链接
      openFooterNav(val) {
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      loadEnroll() {
        var _this = this;
        let url = "/ac1/conference/orderDetail";
        let params = {
          order_no: _this.order_no
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.conference = res.posts.conference.conference;
            _this.list = res.posts.conference.data;
            _this.getTips();
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });

      },
      getTips(){
        var _this = this;
        let url = "/ac1/conference/seat/tips";
        let params = {
          id: _this.conference.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.tips = res.posts;
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
      goSearch(name){
        var _this = this;
        if(!_this.tips.is_search){
          _this.text =  _this.tips.search_tips;
          return false;
        }
        if(name == ''){
          _this.$toast('请输入姓名查询!');
          return false;
        }
        if(name != _this.searchValue){
          _this.searchValue = name;
        }
        let url = "/ac1/conference/seat/search";
        let params = {
          name:name,
          id: _this.conference.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            if(res.posts.length >= 1){
              _this.text = "查询到与“"+name+"”相关的用户有如下几个：";
              _this.list2 = res.posts;
            }else{
              _this.list2 = [];
             // _this.text = "没有查询到与“"+name+"”相关的用户，如有疑问请联系会议客服咨询详情！";
              _this.text = _this.tips.tips;
            }
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
      goPath(item){
        let _this = this;
        _this.$router.push('/mySeat/'+_this.conference.id+'/'+item.numbered+"/"+item.line+'/'+item.column);
      }
    }
  };
</script>
<style lang="less" >
  .van-empty__description{
    text-align: center;
  }
  //座位查询
  .seat_listbox {
    width: 100%;
    min-height: 100vh;
    background: #FFF;
    .topbox{
      width:100%;
      padding: 30px;
      background: #FFF;
      h5{
        font-size: 34px;
        color: #333;
      }
      .van-search{
        width: 100%;
        padding: 0px;
        margin: 24px 0px;
        border-radius: 40px;
        overflow: hidden;
        .van-icon{
          display: none;
        }
        input{
          font-size: 30px;
          line-height: 60px;
        }
      }
      .searchBtn{
        width: 300px;
        height: 80px;
        line-height: 80px;
        display: block;
        margin:  0 auto;
        background: #2b68db;
        color: #FFF;
        border-radius: 80px;
      }
    }
    .s_list{
      width: 100%;
      padding: 30px;
      background: #FFF;
      h5{
        font-size: 30px;
        line-height: 45px;
        color: #333;
      }
      .seat_box{
        width: 100%;
        padding:10px 0px;
        margin-bottom: 20px;
        .van-row{
          padding: 30px 0px;
          border-bottom: 2px solid #ebebeb;
          .van-col{
            font-size: 28px;
            color:#333;
            line-height: 70px;
            .imgbox{
              width: 70px;
              height: 70px;
              float: left;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 20px;
              box-shadow: 2px 3px 5px #999;
              img{
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            p{
              float: left;
              line-height: 70px;
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: calc(~'100% - 90px');
              padding-right: 10px;
            }
            &.number{
              color: #999;
            }
            &.click{
              color: #78a7ff;
              text-align: right;
            }
          }
        }
      }
    }
  }
</style>
